import { ReactNode } from 'react'
import { AdminRoute } from './AdminRoute'
import { AdminLayout } from '@/components/layout/AdminLayout'

interface AdminLayoutRouteProps {
  children: ReactNode
  roles?: string[]
}

/**
 * Combined authentication + layout wrapper for admin routes
 * Follows React Router layout routes best practice
 */
export function AdminLayoutRoute({ children, roles }: AdminLayoutRouteProps) {
  return (
    <AdminRoute roles={roles}>
      <AdminLayout>{children}</AdminLayout>
    </AdminRoute>
  )
}
